// app/adminSL/ordine/asl_ordini.js

(function () {
    'use strict';
    var controllerId = 'asl_ordine';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', '$location', '$filter', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', ordineFn]);

    function ordineFn($rootScope, common, $location, $filter, bDialog, $routeParams, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Ordini';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.super = $rootScope.isAuthorized('SUPER');

        //Filtro
        vm.filter = {};
        vm.filter.commercialeId = 0;
        vm.fCommercialeId = 0;
        vm.filter.docenteId = 0;
        vm.fDocenteId = 0;
        vm.filter.strumF = '';
        vm.fStrumF = '';
        vm.filter.dataOrdine = '';
        vm.fData = '';

        //Filtro
        vm.filter = {};
        vm.filter.nome = ' ';
        
        //Elenchi per filtri e finestra modale di Create e Update                
        vm.docenti = [];
        vm.commerciali = [];
        vm.pagamento = {};        

        //DatePicker
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;            
        };        
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;         
        vm.setIncassato = setIncassato;
        vm.apriFatturaPa = apriFatturaPa;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getCommerciali(), getDocenti()];
            common.activateController(promises, controllerId)
                    .then(function () {

                        if ($routeParams.OrdineId != null) {
                            setView('detail');
                            getRecord($routeParams.OrdineId, 0);                            
                        }
                    });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.commercialeId = vm.fCommercialeId == null ? 0 : vm.fCommercialeId;
            vm.filter.docenteId = vm.fDocenteId == null ? 0 : vm.fDocenteId;
            vm.filter.strumF = vm.fStrumF == null ? '' : vm.fStrumF;
            vm.filter.dataOrdine = vm.fData == null ? '' : $filter('date')(vm.fData, vm.format);

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.ordine_countAll(vm.filter.docenteId, vm.filter.commercialeId, vm.filter.dataOrdine, vm.filter.strumF).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.ordine_getAll(vm.pageSize, vm.page, vm.filter.docenteId, vm.filter.commercialeId, vm.filter.dataOrdine, vm.filter.strumF).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });                    
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.ordine_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.record.Data = common.dateToString(data.Data);
                //azzera liste
                vm.docenti = [];
                vm.commerciali = [];
                
                getDocenteById(vm.record.DocenteId);
                getCommercialeById(vm.record.CommercialeId);
                getPagamento(vm.record.PagamentoId);
                setView('detail');
            });
        }                

        function setIncassato(ordineId, dataIncassato) {            
            if (typeof (dataIncassato) == 'undefined' || dataIncassato == null) {
                logError("Inserisci la Data Incassato");
                return;
            }                

            var msg = "Impostare come incassato l'ordine N " + vm.record.Id + "? L'operazione non e' reversibile.";
            bDialog.confirmationDialog("Conferma", msg).then(function () {
                datacontext.ordine_setIncassato(ordineId, dataIncassato).then(function (data) {
                    if (!data || !data.Id || data.Id == 0) {
                        logError('Operazione non riuscita');
                        return;
                    }

                    vm.record = data;
                    vm.record.Data = common.dateToString(data.Data);
                    getPagamento(vm.record.PagamentoId);
                    logSuccess('Dato modificato');
                });
            });
        }

        function getDocenteById(docenteId) {
            if (typeof (docenteId) == 'undefined' || docenteId == 0)
                return vm.docenti = [];
            return datacontext.risorsa_get(docenteId).then(function (data) {
                var array = { Id: data.Id, Name: data.Cognome + " " + data.Nome };
                return vm.docenti = [array];
            });
        }

        function getCommercialeById(commercialeId) {
            if (typeof (commercialeId) == 'undefined' || commercialeId == 0)
                return vm.commerciali = [];
            return datacontext.commerciale_get(commercialeId).then(function (data) {
                var array = { Id: data.Id, Name: data.Cognome + " " + data.Nome };
                return vm.commerciali = [array];
            });
        }

        function getCommerciali() {
            return datacontext.commerciale_getAllList().then(function (data) {
                return vm.commerciali = data;
            });
        }

        function getDocenti() {
            return datacontext.risorsa_getAllList().then(function (data) {
                return vm.docenti = data;
            });
        }

        function getPagamento(pagamentoId) {
            if (pagamentoId == null) {
                vm.pagamento = {};
                return;
            }

            return datacontext.pagamento_get(pagamentoId).then(function (data) {
                return vm.pagamento = data;
            });
        }                      

        function apriFatturaPa(id) {
            $location.path("/fatturapa/" + id);
        }
    }
})();
